import e from "dayjs";
// src/design/forms/datepicker/calendar-engine/use-cases/english_date/get_previous_month_date.ts
var t = (t) => e(t).subtract(1, "month").format("YYYY-MM-DD");
export { t as get_previous_month_date };

//# sourceMappingURL=get_previous_month_date.js.map